import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=9c90b78c&scoped=true"
var script = {}
import style0 from "./nodata.vue?vue&type=style&index=0&id=9c90b78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c90b78c",
  null
  
)

export default component.exports